import { ComponentUtil } from '../../utils/ComponentUtil';
import { Hooks } from '../../types/Hooks';

ComponentUtil.loader(
  !!document.querySelector(Hooks.ContentAccordion),
  () => import('./ContentAccordion'),
  (ContentAccordion) => {
    ComponentUtil.binder(Hooks.ContentAccordion, ContentAccordion);
  },
);
